import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/:accessName/:pageDate?',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/Home')
  }, {
    path: '/content/:newsid/:accessName/:pageId/:pageDate',
    name: 'Content',
    component: () => import(/* webpackChunkName: "content123" */ '../views/content/Content')
  }, {
    path: '/search',
    name: 'SearchList',
    component: () => import(/* webpackChunkName: "search123" */ '../views/search/SearchList')
  }, {
    path: '/searchDetail/:newsid/:accessName',
    name: 'SearchDetail',
    component: () => import(/* webpackChunkName: "search" */ '../views/search/SearchDetail')
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
